import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Бесплатная система онлайн-записи и CRM для бизнеса | Planna</title>
          <meta name="description" content="Автоматизируйте запись клиентов без абонентской платы. Бесплатная CRM, онлайн-бронирование, расписание и QR-код для стенда. Для салонов, аренды, студий." />
        </Helmet>

        <h1 class="main2">Бесплатная CRM-система и онлайн-запись для бизнеса | Замена тетради и телефона</h1>
        <div class="main0">
        <div class="w60">
          <h2 class="main2 orange">Бесплатная CRM и система онлайн-записи для вашего бизнеса</h2>
          <div class="main3">Откройте мир, где ваши услуги находят клиентов, а администрация работает на автопилоте. Бесплатно — навсегда.
          Представьте платформу, которая становится вашим полноправным партнером в развитии. Она не просто приводит клиентов — она создает комфортный метод взаимодействия, который ценит и ваш бизнес, и ваши сотрудники. И мы не берем за это ни копейки: никаких абонентских плат, скрытых комиссий или процентов за бронирование. Вы платите только стандартную комиссию банка за эквайринг — как при любой обычной онлайн-оплате или смс-информирование при необходимости.</div>
          <h2 class="main2">Привлекайте клиентов, которые уже готовы к бронированию</h2>
          <ul class="main3">
            <li>Ваш отель или салон красоты становится частью их планов, когда они выбирают из тысяч вариантов.</li>
            <li>Ваши товары для аренды — от дизайнерской одежды и профессиональных инструментов до строительного оборудования — находят своего идеального временного владельца.</li>
            <li>Ваш ресторан — на интерактивной схеме зала. Клиенты видят реальную картину: какие столики свободны, какие у окна, а какие в тихой зоне. Они сами выбирают место, которое хотят, а не просто "столик на двоих". А вы управляете залом как дирижёр: цветовая индикация показывает статус каждого стола, а при нажатии открывается полная информация о брони. Никаких распечатанных схем и переспрашиваний "а этот столик занят?".</li>
          </ul>
          <h2 class="main2 orange">Забудьте о путанице: единое пространство для бизнеса и жизни</h2>
          <div class="main3">Наше ключевое преимущество — единое пространство времени. Календарь вашего сотрудника на работе интегрируется с его личным календарем как клиента. Если парикмахер записался к стоматологу, его рабочее расписание автоматически обновится, исключив это время для записи клиентов. Это предотвращает конфликты, снижает стресс и создает прозрачность для всей команды.</div>
          <h2 class="main2 w40">Ваш бизнес заслуживает безупречной организации.</h2>
          <div class="main3 w40">Мы берем на себя управление временем, чтобы вы могли сосредоточиться на качестве услуг. Начните расти без лишних затрат.</div>

          <h2 class="main2 orange">Визуальный выбор во всех деталях</h2>

<div class="main3 w40">Наша система позволяет создать интерактивные схемы и каталоги для любого бизнеса:</div>
<div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
  <thead><tr><th>Тип бизнеса</th><th>Что можно визуализировать</th></tr></thead>
  <tbody>
    <tr>
<td><a href="/business/restaurant">Ресторан, кафе, бар</a></td><td>Схема зала с расстановкой столов</td>
</tr><tr>
<td><a href="/business/hotel">Отель</a></td><td>Выбор конкретного номера на этаже</td>
</tr><tr>
<td><a href="/business/coworking">Коворкинг</a></td><td>План с рабочими местами и переговорными</td>
</tr><tr>
<td><a href="/business/rent">Аренда оборудования или одежды, прокат авто</a></td><td>Каталог с фотографиями каждой единицы</td>
</tr><tr>
<td><a href="/business/event">Мероприятия</a></td><td>Выбор места в зале</td>
</tr>
</tbody></table>
</div><div class="main3 w40">
<div class="main3 w40">Как это работает:</div>
<ul>
<li>Вы загружаете схему или фотографии через простой интерфейс</li>
<li>Настраиваете зоны, цены, правила бронирования</li>
<li>Система автоматически отображает доступность в реальном времени</li>
<li>Клиенты выбирают и бронируют — всё визуально и понятно</li>
</ul>
        </div>
        </div>
        <div class="w40">
          <h2 class="main2">Что вы получаете бесплатно навсегда?</h2>
          <ul class="main3">
            <li>Интеллектуальное расписание учитывает личные планы команды.</li>
            <li>Снижение административной нагрузки. Больше не нужно вручную сверять расписания и согласовывать переносы.</li>
            <li>Ваши сотрудники ценят вас. Вы даете им удобный инструмент для управления их собственным временем — и рабочим, и личным.</li>
            <li>Все бронирования в одном месте, даже если к вам записываются старым способом, на экране вашего смартфона, компьютера или планшета в офисе и смартфонах каждого из ваших сотрудников (собственное расписание с возможностью записи).</li>
            <li>Полная история ваших ресурсов, будь то строительное оборудование, автомобили или сотрудник в одном месте.</li>
            <li>Вы всегда на связи с клиентом. Они видят ваше реальное, актуальное расписание и бронируют услуги 24/7, а вы получаете гарантированно свободный ресурс.</li>
            <li>Единый рейтинг добросовенности клиентов между различными компаниями</li>
            <li>Различные отчеты о загрузке сотрудников, рабочих мест, ежедневные, филиалов</li>
            <li>Гибкие настройки услуг с ценами и возможными дополнительными опциями для каждой услуги</li>
            <li>Собственная страница компании с возможностью бронирования клиентами абсолютно бесплатно, генерация ссылки в виде QR-кода для вывешивания на стенд</li>
            <li>Прозрачные условия. Вы всегда знаете, сколько заплатите за эквайринг и смс-информирование, если подключено, все остальное бесплатно и никаких неожиданностей.</li>
          </ul>
        </div>
        <div class="w40">
          <h2 class="main2">Для кого создана эта система?</h2>
          <ul class="main3">
            <li><a href="/business/beauty">Салоны красоты, массаж, барбершоп</a></li>
            <li>Прокат инструментов и оборудования</li>
            <li>Отель, гостевой дом, аппартаменты</li>
            <li>Ресторан, кафе</li>
            <li>Фитнес-студия, йога-центр</li>
            <li>Аренда одежды</li>
            <li>Коворкинг</li>
            <li>Автосервисы, шиномонтаж и автомойки</li>
            <li>Частный мастер (массаж, репетиторство)</li>
          </ul>
        </div>
        </div>
        <div class="main4 w40 orange">Станьте частью экосистемы, где технологии работают на гармонию вашего бизнеса и жизни вашей команды. Бесплатно навсегда.</div>
        <p></p>
        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (мастер или объект аренды)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
        <p></p>
        <div class="w40">
          <h2 class="main2 orange">Частые вопрос (FAQ)</h2>
          <ul class="main3">
            <li><b>Это правда бесплатно? Не будет ли скрытых платежей?</b><p><b>Ответ:</b> Да, это бесплатно навсегда. Вы не платите ни абонентскую плату, ни проценты с бронирований. Единственный возможный платеж — это комиссия банка за онлайн-оплату, если вы её подключите, и смс-информирование.</p></li>
            <li><b>Как клиенты смогут записаться ко мне?</b><p><b>Ответ:</b> Мы бесплатно создадим для вас страницу с онлайн-записью и сгенерируем QR-код. Разместите его на стойке, или просто ссылку на сайте или в соцсетях — клиенты смогут записываться в 2 клика, 24/7. Вы также сможете записывать клиентов по телефону в нашем приложении или на нашем сайте для избежания двойных бронирований. Полный календарь будет всегда у вас под рукой.</p></li>
          </ul>
        </div>

      </div>
    );
  }
}
